export default __webpack_public_path__ + "static/media/AdvenioTel.3abe69d9.jpg";